import { useState, useEffect } from 'react'
import Header from './components/Header'
import Hero from './components/Hero'
import About from './components/About'
import Services from './components/Services'
import Decorations from './components/Decorations'
import Entertainment from './components/Entertainment'
import Photobooths from './components/Photobooths'
import Contact from './components/Contact'
import Footer from './components/Footer'

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  // Smooth scroll to sections
  useEffect(() => {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault()
        const target = document.querySelector(this.getAttribute('href'))
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
          setMobileMenuOpen(false)
        }
      })
    })
  }, [])

  return (
    <div className="App">
      <Header mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      <Hero />
      <About />
      <Services />
      <Decorations />
      <Entertainment />
      <Photobooths />
      <Contact />
      <Footer />
    </div>
  )
}

export default App
